import { ConfirmController } from './confirm.controller';
import { LoadingController } from './loading.controller';

import { ConfirmService } from './confirm.service';
import { LoadingService } from './loading.service';
import { OverlayService } from './overlay.service';
import { AuthenticatedUserService } from './authenticated-user.service';
import { SessionStorage } from './session-storage.service';
import { UserSessionService } from './user-session.service';
import { DestinationService } from './destination-installation.service';
import { ServerConfiguration } from './server-configuration';
import { ErrorService } from './error.service';
import { AccessRightService } from './access-right.service';
import { HttpService } from './HttpService';
import { AccessDeniedComponent } from './AccessDeniedComponent';


import { egtoOverlay } from './overlay.directive';

export var sharedModule = angular.module('authentication.shared', [
        'pascalprecht.translate',
        'ngAnimate',
        'ui.router'
    ])
    .controller('ConfirmController', ConfirmController)
    .controller('LoadingController', LoadingController)
    .component('accessDenied', AccessDeniedComponent)
    .service('confirmService', ConfirmService)
    .service('loadingService', LoadingService)
    .service('overlayService', OverlayService)
    .service('authenticatedUserService', AuthenticatedUserService)
    .service('sessionStorage', SessionStorage)
    .service('userSessionService', UserSessionService)
    .service('destinationService', DestinationService)
    .service('serverConfiguration', ServerConfiguration)
    .service('errorService', ErrorService)
    .service('accessRightService', AccessRightService)
    .service('egHttpService', HttpService)
    .directive('egtoOverlay', egtoOverlay)
    .constant('LOG_LEVEL', 0)
    ;
